module.exports = __webpack_public_path__ + "static/img/nioicon.e70cadaa.svg";